import { Grid, Paper, useMediaQuery } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MapHomeComponent from "../components/map/MapHome.component";
import { useDispatch, useSelector } from "react-redux";
import HomeAreaChartComponent from "shared-components/src/components/charts/homeAreaChart.component";
import WeatherForecastComponent from "shared-components/src/components/weatherForecast/WeatherForecastNew.component";
import { fetchWaterModelsDataRequest } from "../store/actions/waterModelData.actions";
import FieldsListContainer from "../components/fieldsListContainer/fieldsListContainer.component";
import { fetchWaterSystemRequest } from "../store/actions/waterSystems.actions";
import WaterActivationBox from "../components/waterActivationBox/waterActivationBox.component";

const HomePage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 767px");

  const [fieldsIrrigationStatus, setFieldsIrrigationStatus] = useState({});
  const [isMapLoading, setIsMapLoading] = useState(true);

  const weatherForecast = useSelector((state) => state.weatherForecast).data;
  const position = useSelector(
    (state) => state.fields?.data?.[0]?.polygons?.[0]?.position?.[0]
  );
  const fields = useSelector((state) => state.fields?.data);

  const waterModelData = useSelector((state) => state.waterModelData?.data);
  const token = useSelector((state) => state.auth?.token);
  const waterAuthority = useSelector(
    (state) => state.user?.data?.water_authority
  );
  const waterSystems = useSelector((state) => state.waterSystems?.data?.data);
  const waterThing =
    waterSystems?.[0]?.attributes?.water_systems?.data?.find(
      (system) => system.attributes?.id_thing === "acquaountcantonierareservoir"
    )?.attributes?.id_thing || "";
  const activeWaterDashboard = useSelector(
    (state) => state.user?.data?.active_dashboard_water
  );

  const modelData = waterModelData?.modelOutputs;

  const volumeData =
    modelData?.data?.filter((item) => item.measure === "storage") || [];

  const handleIrrigationStatusChange = (status, loading) => {
    setFieldsIrrigationStatus(status);
    setIsMapLoading(loading);
  };

  useEffect(() => {
    if (waterThing && activeWaterDashboard) {
      dispatch(fetchWaterModelsDataRequest(waterThing));
    }
  }, [dispatch, waterThing, activeWaterDashboard]);

  useEffect(() => {
    if (waterAuthority) {
      dispatch(fetchWaterSystemRequest());
    }
  }, [dispatch, waterAuthority]);

  return (
    <Fragment>
      <Grid
        container
        spacing={2}
        sx={{ marginBottom: "20px", marginTop: "5px" }}
      >
        {/* Weather and Overview */}
        <Grid item xs={12} md={4}>
          {weatherForecast && (
            <Paper
              variant="outlined"
              sx={{
                height: "100%",
                paddingX: "20px",
                paddingBottom: "20px",
                marginBottom: isMobile ? undefined : "10px",
              }}
            >
              <h3>{t("home.weather-forecast")}</h3>
              <div style={{ minHeight: "100%" }}>
                <WeatherForecastComponent position={position} />
              </div>
            </Paper>
          )}
        </Grid>
        <Grid item xs={12} md={8}>
          <Paper
            variant="outlined"
            sx={{ height: "100%", paddingX: "20px", paddingBottom: "20px" }}
          >
            <h3>{t("home.oveview")}</h3>
            <MapHomeComponent
              fieldsIrrigationStatus={fieldsIrrigationStatus}
              isLoading={isMapLoading}
            />
          </Paper>
        </Grid>
        {/* Water forecast and planning */}
        <Grid item xs={12} sm={12} md={12} lg={4}>
          <FieldsListContainer
            fields={fields}
            t={t}
            token={token}
            onIrrigationStatusChange={handleIrrigationStatusChange}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={8}>
          {!isMobile && (
            <Paper
              variant="outlined"
              sx={{ height: "100%", paddingX: "20px", paddingBottom: "20px" }}
            >
              {waterAuthority && activeWaterDashboard ? (
                <>
                  <h3>{t("home.months-water-forecast")}</h3>
                  <HomeAreaChartComponent volumeData={volumeData} />
                </>
              ) : (
                <WaterActivationBox />
              )}
            </Paper>
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default HomePage;
